<script>
import { mapGetters } from "vuex";

export default {
  name: 'discountCoupons',
  data() {
    return {
      copyTarget: '',
      datePickerOptions: {
        firstDayOfWeek: 1,
        disabledDate: this.handleDisabledDate
      },
      windowWidth: 0
    }
  },
  computed: {
    ...mapGetters({
      couponsList: 'discountCoupons/getCouponsList',
      planGroups: 'discountCoupons/getPlanGroups',
      planTypes: 'discountCoupons/getPlanTypesByGroup',
      discounts: 'discountCoupons/getDiscounts'
    }),
    planGroupsList() {
      return [{label: 'All', value: null}].concat(this.formatList(this.planGroups))
    },
    planTypesByGroup() {
      return this.formatList(this.planTypes)
    },
    discounSelectList() {
      const resultArr = []
      Object.entries(this.discounts).forEach(item => resultArr.push({ label: item[1].name, value: Number(item[1].id) }))
      return resultArr
    },
    formLabelByScreenWidth() {
      return {
        position: window.innerWidth < 550 ? 'top' : 'left',
        width: window.innerWidth < 650 ? '25px' :
            window.innerWidth < 992 ? '50px' :
                window.innerWidth < 1200 ? '75px' : '125px'
      }
    }
  },
  methods: {
    //handle window resize
    handleWindowResize() {
      this.windowWidth = window.innerWidth
    },

    // Plan group selector change handler
    handlePlanGroupChange(value) {
      this.form.plan_type_id = value ? '' : null;
      this.$store.dispatch('discountCoupons/getPlanTypesByGroup', value)
    },

    // datepicker date disable handler
    handleDisabledDate(date) {
      return date < new Date() - 1000 * 60 * 60 * 24
    },

    // handle copy to clipboard
    handleCopy(target) {
      this.copyTarget = target
    },

    // capitalize first letter in word
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    },

    // format plan groups, types, discounts from arr to obj
    formatList(list) {
      const resultArr = []

      Object.entries(list).forEach(item => resultArr.push({ label: item[1], value: !Number(item[0]) ? null : Number(item[0]) }))

      return resultArr
    },

    // data type conversion to str or num
    typeConversion(type, prop) {
      const conversion = {
        'str': prop !== null ? prop.toString() : null,
        'num': prop !== null ? Number(prop) : null
      }

      return conversion[type]
    },

    // filter coupons list by coupon id
    filterCouponsListById(couponId) {
      return this.couponsList.filter(coupon => coupon.id === couponId).shift()
    }
  },
  created() {
    this.$store.dispatch('discountCoupons/getPlanTypesByGroup', null)
    window.addEventListener('resize', this.handleWindowResize)
    this.handleWindowResize()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize)
  }
}
</script>

<style lang="scss" scoped>
  .form-block {
    .result-block {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      margin-bottom: 15px;
      padding: 10px;
      border: 1px solid #DCDFE6;
      border-radius: 10px;

      .result-block-options {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-bottom: 10px;
        border-bottom: 1px solid #DCDFE6;

        .result-block-title {
          font-size: 14px;
          font-weight: 600;
        }

        .close-result-block {
          font-size: 28px;
          color: #bdbfc3;
          border: none;
          background: transparent!important;

          &:hover {
            color: #5f8fdf
          }
        }
      }

      &-row {
        display: flex;
        justify-content: space-around;

        .result-block-column {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          margin-right: 75px;

          &:first-child {
            .result-item {
              .label {
                width: 75px;
                margin-right: 15px;
                font-weight: 600;
                font-size: 14px;
              }

              .value {
                font-size: 14px;
                color: #525252;
              }
            }
          }

          &:nth-child(2) {
            .result-item {
              .label {
                width: 100px;
                margin-right: 15px;
                font-weight: 600;
                font-size: 14px;
              }

              .value {
                font-size: 14px;
                color: #525252;
              }
            }
          }

          &:nth-child(3) {
            .result-item {
              .label {
                width: 50px;
                margin-right: 15px;
                font-weight: 600;
                font-size: 14px;
              }

              .value {
                font-size: 14px;
                color: #525252;
              }
            }
          }

          .result-item {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding-top: 5px;
          }
        }
      }
    }

    .coupon-form {
      .links-row {
        display: flex;
        flex-direction: row;
        border: 1px solid #DCDFE6;
        border-radius: 10px;

        &-block {
          display: flex;
          flex-direction: row;
          align-items: center;

          &:first-child {
            width: 50%;
            padding-left: 15px;
          }

          &:last-child {
            width: 50%;
            padding-right: 15px;
          }

          &__item {
            &:first-child {
              width: 90%;
            }
          }
        }
      }

      .settings-row {
        display: flex;
        flex-direction: row;
        border: 1px solid #DCDFE6;
        border-radius: 10px;
        margin: 10px 0;
        padding: 25px 0;

        &-block {
          display: flex;
          flex-direction: column;
          align-items: center;

          &:first-child {
            width: 50%;
            border-bottom: none;
            border-right: 1px solid #DCDFE6;
            padding: 0 0 0 50px;
          }

          &:last-child {
            width: 50%;
            padding: 0 0 0 50px;
          }

          .switch-item {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

          }
          &__item {
            width: 100%;

            .el-form-item {
              .form-item-input {
                width: 225px;
              }
              .item-label {
                font-size: 16px;
                font-weight: 600;
              }
            }
          }
        }
      }

      .submit-row {
        display: flex;
        flex-direction: row;
        justify-content: center;

        &-block {
          &__item {
            .submit-btn {
              width: 200px;
              font-size: 15px;
            }
          }
        }
      }
    }
  }
</style>
